module.exports = __webpack_public_path__ + "assets/tooltip-question-mark.cd2d6ec2.svg";